import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetInstituteRegistrationListQuery } from 'src/rtk/features/instituteAndDepartmentRegistration/instituteAndDepartmentRegistrationApi';
import InstituteDeptRegistrationStepFive from './InstituteDeptRegistrationStepFive';
import InstituteDeptRegistrationStepFour from './InstituteDeptRegistrationStepFour';
import InstituteDeptRegistrationStepOne from './InstituteDeptRegistrationStepOne';
import InstituteDeptRegistrationStepSeven from './InstituteDeptRegistrationStepSeven';
import InstituteDeptRegistrationStepThree from './InstituteDeptRegistrationStepThree';
import InstituteDeptRegistrationStepTwo from './InstituteDeptRegistrationStepTwo';
import InstituteDeptRegistrationStepSix from './InstituteDeptRegistrationStepSix';

const EditInstituteDeptRegistration = () => {
    const { departmentId: deptId, formBId: formBDeptId } = useParams<{ departmentId: string; formBId: string }>();
    const [currentStep, setCurrentStep] = useState<number>(1);
    const [instituteName, setInstituteName] = useState<string>('');
    const [instituteLocation, setInstituteLocation] = useState<string>('');
    const [newDeptId, setNewDeptId] = useState<string>(deptId);

    const { data: instituteRegData, isSuccess: isInstituteRegDataSuccess, isError: isInstituteRegDataError, error: instituteRegDataError } = useGetInstituteRegistrationListQuery();

    const goToNext = (departmentId?: string, formBDeptId?: string) => {
        if (currentStep < 7) {
            setCurrentStep((p: number) => p + 1);
        } else {
            setCurrentStep(1);
        }

        if (departmentId) {
            // console.log(departmentId);
            setNewDeptId(departmentId);
        }
    };

    const goToPrevious = (departmentId?: string, formBDeptId?: string) => {
        if (currentStep > 1) {
            setCurrentStep((p: number) => p - 1);
        } else {
            setCurrentStep(7);
        }
    };

    document.title = 'Training Accreditation Application Form | BCPS';

    useEffect(() => {
        if (isInstituteRegDataSuccess) {
            setInstituteName(instituteRegData?.data?.institute_name!);
            setInstituteLocation(instituteRegData?.data?.institute_location!);
        }
    }, [isInstituteRegDataSuccess]);

    return (
        <>
            {currentStep === 1 && <InstituteDeptRegistrationStepOne goToNext={goToNext} instituteName={instituteName} instituteLocation={instituteLocation} departmentId={newDeptId} formBDeptId={formBDeptId} />}
            {currentStep === 2 && <InstituteDeptRegistrationStepTwo goToNext={goToNext} goToPrevious={goToPrevious} instituteName={instituteName} departmentId={newDeptId} formBDeptId={formBDeptId} />}
            {currentStep === 3 && <InstituteDeptRegistrationStepThree goToNext={goToNext} goToPrevious={goToPrevious} instituteName={instituteName} departmentId={newDeptId} formBDeptId={formBDeptId} />}
            {currentStep === 4 && <InstituteDeptRegistrationStepFour goToNext={goToNext} goToPrevious={goToPrevious} instituteName={instituteName} departmentId={newDeptId} formBDeptId={formBDeptId} />}
            {currentStep === 5 && <InstituteDeptRegistrationStepFive goToNext={goToNext} goToPrevious={goToPrevious} instituteName={instituteName} departmentId={newDeptId} formBDeptId={formBDeptId} />}
            {currentStep === 6 && <InstituteDeptRegistrationStepSix goToNext={goToNext} goToPrevious={goToPrevious} instituteName={instituteName} departmentId={deptId} formBDeptId={formBDeptId} />}
            {currentStep === 7 && <InstituteDeptRegistrationStepSeven goToPrevious={goToPrevious} instituteName={instituteName} departmentId={newDeptId} formBDeptId={formBDeptId} />}
        </>
    );
};

export default EditInstituteDeptRegistration;
